import { render, staticRenderFns } from "./CruisePortsPopup.vue?vue&type=template&id=5164a365&scoped=true"
import script from "./CruisePortsPopup.vue?vue&type=script&lang=js"
export * from "./CruisePortsPopup.vue?vue&type=script&lang=js"
import style0 from "./CruisePortsPopup.vue?vue&type=style&index=0&id=5164a365&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164a365",
  null
  
)

export default component.exports